import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Activity, BarChart2, Download, Edit2, Filter, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {HiOutlineViewList} from "react-icons/hi";
import DeletePhysicalEventModal from "./modals/DeletePhysicalEventModal";
import PhysicalEventRoiModal from "./modals/PhysicalEventRoiModal";
import { exportEventAttendees } from "../helpers/attendeesExport";
import { costPerRegistrationLabel } from "../helpers/eventCosts";
import AddEventModal from "./modals/AddEventModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { apiFetch, API, getMarket } from "../services/api";

function getEvents() {

    return apiFetch(API.back + '/physical-events', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function updateState(event, checked) {
    event.state = checked
    event.language = getMarket()
    return apiFetch(API.back + '/physical-event', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(event)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

export class EventsList extends Component {
    state = {
        errors: null,
        selectedEvent: {
            login: "",
            email: "",
            password: "",
            name: "",
            phoneNumber: "",
        }
    }

    async componentDidMount() {
        await getEvents().then(data => {
            this.setState({events: data})
        }).catch(err =>
            this.setState({errors: "error while getting events"})
        );
    };

    closeModal = () => this.setState({
        isOpen: false,
        isDelete: false,
        isDrawing: false,
        isRoi: false,
        selectedEvent: {
            name: "",
            description: "",
            beginDate: "",
            endDate: "",
            logo: "",
            cover: ""
        }
    });

    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={11} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"
                                onClick={(e) => this.setState({isOpen: true})}>Ajouter un évènement</Button>
                    </Col>
                    <Col sm={1} className="products-buttons">
                        <ToggleButtonGroup value={this.state.mode} type="checkbox">
                            <ToggleButton
                                key={2}
                                type="radio"
                                variant="secondary"
                                name="radio"
                                value={"Liste"}
                                onChange={(e) => this.setState({mode: e.currentTarget.value})}
                            >
                                <HiOutlineViewList/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={11} className="products-buttons">
                        {(this.state.events && this.state.events.length > 0 && this.state.errors == null) ? <span>{this.state.events.length} évenement{this.state.events.length == 1 ? "": "s"}</span> : null }
                    </Col>
                </Row>
                { this.state.errors != null ? <p>"Erreur lors de la récupération des évènements, veuillez vous reconnecter"</p> : null}

                { (!this.state.events && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <th></th>
                        <th>Nom</th>
                        <th>Date</th>
                        <th>Lieu</th>
                        <th>Nombre de TRCoins offerts</th>
                        <th>Nombre de places</th>
                        <th>Nombre de participants</th>
                        <th>Coût / inscrit (hors Ads)</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        </thead>
                        <tbody>
                        {this.state.events.map(event => (
                            <tr>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Afficher l'évènement sur l'app</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={event.state}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updateState(event, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <td>{event.name}</td>
                                <td>{event.date}</td>
                                <td>{event.town}</td>
                                <td>{event.countOfCoins}</td>
                                <td>
                                    {event.countOfAttendee}
                                    {(event.isPaddock || event.isVMA) ? <div className="text-muted small">par créneau</div> : null}
                                </td>
                                <td>
                                    {event.countOfHumans}
                                    {/* Paddock/VMA : la capacité vaut PAR créneau → détail des inscrits par créneau, créneau plein en rouge */}
                                    {(event.isPaddock || event.isVMA) && event.countOfHumansBySlot ?
                                        Object.entries(event.countOfHumansBySlot).sort(([a], [b]) => a.localeCompare(b)).map(([slot, count]) => (
                                            <div key={slot} className={"small " + (count >= event.countOfAttendee ? "text-danger" : "text-muted")}>
                                                {slot} : {count} / {event.countOfAttendee}
                                            </div>
                                        ))
                                    : null}
                                </td>
                                <td>
                                    {costPerRegistrationLabel(event)}
                                    <div className="text-muted small">Ads : voir ROI</div>
                                </td>
                                <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">Voir le ROI et le coût par inscription</Tooltip>}>
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <BarChart2 className="align-middle mr-1" size={18} onClick={() => this.setState({isRoi: true, selectedEvent: event})}/>
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Exporter les participants (CSV : créneau, marque, nom, prénom)</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Download className="align-middle mr-1" size={18}
                                                  onClick={() => exportEventAttendees(event).catch(err => { console.log(err); alert("Export impossible : " + err); })}/>
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Modifier l'évènement</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Edit2 className="align-middle mr-1" size={18}
                                               onClick={(e) => this.setState({isOpen: true, selectedEvent: event})}/>
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Supprimer l'évènement</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Trash className="align-middle" size={18}
                                               onClick={(e) => this.setState({isDelete: true, selectedEvent: event})}/>
                                    </td>
                                </OverlayTrigger>

                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
                {this.state.isOpen ?
                    <AddEventModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        selectedEvent={this.state.selectedEvent}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeletePhysicalEventModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedEvent}
                        selectedCategory="physical-event"
                    />
                    :
                    null
                }
                {this.state.isRoi ?
                    <PhysicalEventRoiModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isRoi}
                        selectedEvent={this.state.selectedEvent}
                    />
                    :
                    null
                }
            </div>
        );

    }
}